import { styled } from '@mui/material';

export const TablesWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 24,
  border: '1px solid #DADADA',
  backgroundColor: '#FFFFFF',
});
